import SocketClient from 'socket.io-client';

import $path from '@/utils/path';

let socketIO = null;

export default {
  open() {
    if (!socketIO) {
      const { server, path } = $path.resolveSocket();
      socketIO = SocketClient(server, {
        path, // path: `${PathUtils.resolve('socket').path}/socket.io`,
        transports: ['polling', 'websocket'],
      });
    }
  },
  subscribe(eventName, method) {
    if (socketIO) {
      socketIO.on(eventName, method);
    }
  },
  emit(eventName, method) {
    if (socketIO) {
      socketIO.emit(eventName, method);
    }
  },
  close() {
    if (socketIO) {
      socketIO.removeAllListeners();
      socketIO.close();
      socketIO = null;
    }
  },
};
